import Main from './components/Main.vue';

const meta = {
  layout: 'master',
  requiresAuth: true,
};

export default [
  {
    path: '/financial/reports',
    component: () => import(/* webpackChunkName: "financial-reports" */ './components/Main.vue'),
    children: [
      { path: '', component: Main, meta },
    ],
    meta,
  },
];
